export const convertArrayToQueryString = (array: string[], name: string): string => {
  if (!array) {
    return '';
  }
  let result = ``;
  array.forEach((item) => {
    result += `&filters[${name}][]=` + item;
  });
  return result;
};

export const filters: FilterSection[] = [
  {
    width: '180px',
    filterName: 'fulfillmentStatus',
    items: [
      { value: 'canceled' },
      { value: 'pending' },
      { value: 'processing' },
      { value: 'fulfilled' },
    ],
  },
  {
    width: '130px',
    filterName: 'deliveryType',
    items: [
      { value: 'NXD' },
      { value: 'SMD' },
      { value: 'CO2F' },
      { value: 'RET' },
      { value: 'NAL' },
      { value: 'EXN' },
      { value: 'EXO' },
      { value: 'XBD' },
    ],
  },
];

export interface FilterSection {
  width: string;
  filterName: string;
  items: FilterItems[];
}

interface FilterItems {
  value: string;
}
